import React, { FC, useEffect, useRef, useState } from 'react';
import { BUITheme, Dialog } from '@blofin/blofin-ui';
import WarningIcon from '../assets/icons/warning-orange.svg';
import styles from './index.module.scss';
import { useTranslations } from 'next-intl';
import useColor from './useColor';

const IpDialog: FC<{ theme?: BUITheme }> = ({ theme }) => {
  const { open, setOpen } = useColor();

  const t = useTranslations('common');

  const cancel = () => {
    setOpen(false);
    sessionStorage.setItem('ip_restricted', JSON.stringify(true));
  };

  const confirm = () => {
    sessionStorage.removeItem('ip_restricted');
    window.location.href = `${window.location.origin}/forbidden`;
  };

  // IP限制弹窗
  return (
    <Dialog
      title={null}
      size="small"
      open={open}
      cancelText={t('ipCancel')}
      confirmText={t('ipConfirm')}
      footerSize="large"
      footerLayout="center"
      cancel={cancel}
      confirm={confirm}
      theme={theme}
      content={
        <div className="pt-[40px]">
          <WarningIcon className={styles.icon} />
          <p className="text-base-label">{t('ipTip')}</p>
        </div>
      }
    ></Dialog>
  );
};

export { IpDialog };
